export default __webpack_public_path__ + "media/transfer_window/email-verification-lock-e6ed8c56.svg";